import React from "react";
import { useEffect } from "react";

import { useState } from "react";
import useStore from "../../Hooks/useStore";

import Editor from "../Editor/Editor";
import classes from "./CodingWindow.module.css";

export default function CodingWindow() {
  const [htmlFile, setHtml] = useStore("html", "");
  const [cssFile, setCss] = useStore("css", "");
  const [jsFile, setJs] = useStore("js", "");
  const [srcDoc, setSrcDoc] = useState("");

  useEffect(() => {
    const timeout = setTimeout(() => {
      setSrcDoc(`
        <html>
          <body>${htmlFile}</body>
          <style>${cssFile}</style>
          <script> ${jsFile}</script>
        </html>
      `);
    }, 250);

    return () => clearTimeout(timeout);
  }, [htmlFile, cssFile, jsFile]);

  return (
    <div className={classes.coadingWinow}>
      <div className={classes.editorContainer}>
        <Editor
          language="html"
          displayName="HTML"
          value={htmlFile}
          onChange={setHtml}
        />
        <Editor
          language="css"
          displayName="CSS"
          value={cssFile}
          onChange={setCss}
        />
        <Editor
          language="javascript"
          displayName="Js"
          value={jsFile}
          onChange={setJs}
        />
      </div>
      <div className={classes.iframe}>
        <iframe
          srcDoc={srcDoc}
          title="output"
          sandbox="allow-scripts"
          width="99.7%"
          height="100%"
        />
      </div>
    </div>
  );
}
